export default __webpack_public_path__ + "static/media/Img@2x.6f121343.png";